export default __webpack_public_path__ + "static/video-mobile-e4ddcd73fdadd767b979d8b2a86d81f7.webm";